// src/components/StudentAttendance.js
import React from 'react';
import './StudentAttendance.css';

const StudentAttendance = ({ data }) => {
  return (
    <div className="student-attendance">
      {data && data.students && data.students.length > 0 ? (
        data.students.map((student) => (
          <div key={student.student_uid} className="student">
            <h2>
              {student.full_name + ' /UID:' + student.student_uid} ({student.class_admitted})
            </h2>
            <table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {student.attendance && student.attendance.length > 0 ? (
                  student.attendance.map((record, index) => (
                    <tr key={index}>
                      <td>{record.date}</td>
                      <td>{record.status}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2">No attendance records available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        ))
      ) : (
        <div>No student data available</div>
      )}
    </div>
  );
};

export default StudentAttendance;
